/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioTipoRegimenCV from './controladorVista/formularioTipoRegimenCV';
import TablaTipoRegimenCV from './controladorVista/tablaTipoRegimenCV';
import { estadoIncial, reductor } from './reductorTipoRegimen';

const TipoRegimen: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTipoRegimenCV />
        <FormualrioTipoRegimenCV />
    </ProveedorEstado>
);

export default TipoRegimen;
